/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddCarrierSignificantEventRequest
 */
export interface AddCarrierSignificantEventRequest {
  /**
   *
   * @type {string}
   * @memberof AddCarrierSignificantEventRequest
   */
  carrierIdentifier: string;
  /**
   *
   * @type {LocalDate}
   * @memberof AddCarrierSignificantEventRequest
   */
  occurredOn: LocalDate;
  /**
   *
   * @type {string}
   * @memberof AddCarrierSignificantEventRequest
   */
  title: string;
}

/**
 * Check if a given object implements the AddCarrierSignificantEventRequest interface.
 */
export function instanceOfAddCarrierSignificantEventRequest(
  value: object,
): value is AddCarrierSignificantEventRequest {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("occurredOn" in value) || value["occurredOn"] === undefined)
    return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  return true;
}

export function AddCarrierSignificantEventRequestFromJSON(
  json: any,
): AddCarrierSignificantEventRequest {
  return AddCarrierSignificantEventRequestFromJSONTyped(json, false);
}

export function AddCarrierSignificantEventRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddCarrierSignificantEventRequest {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    occurredOn: json["occurredOn"],
    title: json["title"],
  };
}

export function AddCarrierSignificantEventRequestToJSON(
  json: any,
): AddCarrierSignificantEventRequest {
  return AddCarrierSignificantEventRequestToJSONTyped(json, false);
}

export function AddCarrierSignificantEventRequestToJSONTyped(
  value?: AddCarrierSignificantEventRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    occurredOn: value["occurredOn"],
    title: value["title"],
  };
}
